/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAnnouncementBar = {
  init: function($section){
    Shopify.theme.jsAnnouncementBar = $.extend(this, Shopify.theme.getSectionData($section));

    let template = this.homepage_only ? '.index' : '';
    this.$el = $('#announcement-bar', template);
    let announcementCookie = Cookies.get('announcement-bar');

    if (this.show_close_icon === false) {
      Cookies.remove('announcement-bar');
      $('body').addClass('announcement-bar--visible');

      if (Shopify.theme_settings.header_layout == 'vertical') {
        this.addVerticalHeaderTopMargin();
      }

    } else if (announcementCookie !== 'dismiss') {
      $('body').addClass('announcement-bar--visible');

      if (Shopify.theme_settings.header_layout == 'vertical') {
        this.addVerticalHeaderTopMargin();
      }

    } else {
      $('body').addClass('announcement-bar--hidden');
      this.disableSticky();

      if (Shopify.theme_settings.header_layout == 'vertical') {
        this.removeVerticalHeaderTopMargin();
      }

      return false;
    }

    if (this.show_close_icon === true) {
      $('body').addClass('has-announcement-bar-toggle');

      this.$el.on('click', '.js-close-announcement', () => {
        this.hide();

        if (Shopify.theme_settings.header_layout == 'vertical') {
          this.removeVerticalHeaderTopMargin();
        }
      });
    }

    // Slider pehle initialize karo
    if (this.slider === true) {
      let $sliderEl = $section.find('[data-slider]');
      this.createSlider($sliderEl);
    }

    // Sticky slider ke baad enable karo
    setTimeout(() => {
      if (this.enable_sticky === true) {
        this.enableSticky();
      } else {
        this.disableSticky();
      }
    }, 100);
  },
  addVerticalHeaderTopMargin: function() {
    if (isScreenSizeLarge()) {
      const height = this.getAnnouncementHeight();

      $('.header--vertical').css('marginTop', -height + 'px');
      $('.announcement-bar__shadow').height(height);
    }
  },
  removeVerticalHeaderTopMargin: function () {
    // Remove negative margin
    $('.header--vertical').removeAttr('style');
  },
  enableSticky: function() {
    const announcementHeight = this.getAnnouncementHeight();

    this.$el.parent().unstick();

    this.$el.parent().sticky({
      wrapperClassName: 'announcement-sticky-wrapper',
      zIndex: 49
    });

    setTimeout(() => {
      const finalHeight = this.getAnnouncementHeight();

      this.$el.closest('.announcement-sticky-wrapper').css({
        height: finalHeight + 'px'
      });

      $('.announcement-bar__shadow').height(finalHeight);

      this.resetHeader(finalHeight);
    }, 50);
  },
  disableSticky: function() {

    // Remove sticky functionality and recalculate offset for header sticky
    this.$el.parent().unstick();

    this.resetHeader(0);
  },
  hide: function() {

    // Remove announcement bar and set cookie to hide it for 30 days
    $('body').removeClass('announcement-bar--visible');
    this.disableSticky();
    Cookies.set('announcement-bar', 'dismiss', { expires: 30 });
  },
  resetHeader: function(offset) {
    if (Shopify.theme.jsHeader.enable_sticky === true && isScreenSizeLarge()) {
      if (Shopify.theme_settings.header_layout != 'vertical') {
        // Reset desktop sticky header
        Shopify.theme.jsHeader.disableSticky();
        Shopify.theme.jsHeader.enableSticky(offset);
      }
    } else if (Shopify.theme.jsHeader.enable_sticky === true && !isScreenSizeLarge()) {
      // Reset mobile sticky header
      Shopify.theme.mobileMenu.disableSticky();
      Shopify.theme.mobileMenu.enableSticky(offset);
    }
  },
  getAnnouncementHeight: function() {
    let height = 0;

    if (this.$el && this.$el.length) {
      height = this.$el[0].getBoundingClientRect().height;
    }

    return Math.round(height) || 38;
  },
  createSlider: function ($sliderEl) {
    if (!$sliderEl.length) return;

    const slider = $sliderEl.flickity({
      freeScroll: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: false,
      cellAlign: 'left',
      contain: false,
      pauseAutoPlayOnHover: false,
      selectedAttraction: 0.01,
      friction: 0.15,
      autoPlay: false,
      imagesLoaded: true,
      resize: true
    });

    let flkty = slider.data('flickity');
    let requestId;

    function marquee() {
      if (flkty) {
        flkty.x = (flkty.x - 1.0) % flkty.slideableWidth;
        flkty.selectedIndex = flkty.dragEndRestingSelect();
        flkty.updateSelectedSlide();
        flkty.settle(flkty.x);
      }

      requestId = window.requestAnimationFrame(marquee);
    }

    marquee();

    slider.on('mouseenter', function() {
      window.cancelAnimationFrame(requestId);
    });

    slider.on('mouseleave', function() {
      marquee();
    });

    setTimeout(() => {
      const finalHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();

      Shopify.theme.jsAnnouncementBar.$el
        .closest('.announcement-sticky-wrapper')
        .css('height', finalHeight + 'px');

      $('.announcement-bar__shadow').height(finalHeight);

      if (
        Shopify.theme.jsAnnouncementBar.enable_sticky === true &&
        Shopify.theme.jsHeader.enable_sticky === true &&
        isScreenSizeLarge()
      ) {
        Shopify.theme.jsHeader.disableSticky();
        Shopify.theme.jsHeader.enableSticky(finalHeight);
      }
    }, 300);
  },
  unload: function($section) {

    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');

    // Clear event listeners in theme editor
    $('#announcement-bar').off();
    $('#announcement-bar').unstick();
    
  }
}

/******/ })()
;